'use strict';

var React = require('react');

var SvgCircleLeftIcon = function SvgCircleLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.5 10a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm1.5 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-3.5.75a.75.75 0 0 0 0-1.5h-5.19l1.22-1.22a.75.75 0 0 0-1.06-1.06l-2.5 2.5a.75.75 0 0 0 0 1.06l2.5 2.5a.75.75 0 0 0 1.06-1.06l-1.22-1.22h5.19Z"
  }));
};
SvgCircleLeftIcon.displayName = "CircleLeftIcon";

exports.SvgCircleLeftIcon = SvgCircleLeftIcon;
